module.exports = __webpack_public_path__ + "4-87.gif?6f3c9086c33a875139899c681229e64f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-87.gif
// module id = 168
// module chunks = 0